import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _27f82222 = () => interopDefault(import('../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _4da4ba42 = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _23784316 = () => interopDefault(import('../pages/accredited-by-cru.vue' /* webpackChunkName: "pages/accredited-by-cru" */))
const _152c4e05 = () => interopDefault(import('../pages/ads/index.vue' /* webpackChunkName: "pages/ads/index" */))
const _43d92d58 = () => interopDefault(import('../pages/awards.vue' /* webpackChunkName: "pages/awards" */))
const _7f2baa92 = () => interopDefault(import('../pages/money.vue' /* webpackChunkName: "pages/money" */))
const _4df49d7a = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _4e66ecf2 = () => interopDefault(import('../pages/careers.vue' /* webpackChunkName: "pages/careers" */))
const _173f7462 = () => interopDefault(import('../pages/commission-summary.vue' /* webpackChunkName: "pages/commission-summary" */))
const _65ad2cce = () => interopDefault(import('../pages/compare-car-insurance/index.vue' /* webpackChunkName: "pages/compare-car-insurance/index" */))
const _6c678a50 = () => interopDefault(import('../pages/compare-credit-cards/index.vue' /* webpackChunkName: "pages/compare-credit-cards/index" */))
const _5ce46c43 = () => interopDefault(import('../pages/compare-current-accounts/index.vue' /* webpackChunkName: "pages/compare-current-accounts/index" */))
const _69b526a3 = () => interopDefault(import('../pages/compare-gas-electricity-prices/index.vue' /* webpackChunkName: "pages/compare-gas-electricity-prices/index" */))
const _4d41071c = () => interopDefault(import('../pages/compare-health-insurance/index.vue' /* webpackChunkName: "pages/compare-health-insurance/index" */))
const _3ddb9a16 = () => interopDefault(import('../pages/compare-home-insurance/index.vue' /* webpackChunkName: "pages/compare-home-insurance/index" */))
const _20052d72 = () => interopDefault(import('../pages/compare-insurance/index.vue' /* webpackChunkName: "pages/compare-insurance/index" */))
const _6646bc92 = () => interopDefault(import('../pages/compare-life-insurance/index.vue' /* webpackChunkName: "pages/compare-life-insurance/index" */))
const _64aa54a0 = () => interopDefault(import('../pages/compare-loans/index.vue' /* webpackChunkName: "pages/compare-loans/index" */))
const _ea412cf8 = () => interopDefault(import('../pages/compare-mortgages/index.vue' /* webpackChunkName: "pages/compare-mortgages/index" */))
const _3d395714 = () => interopDefault(import('../pages/compare-prepaid-credit-cards/index.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/index" */))
const _144315fa = () => interopDefault(import('../pages/compare-savings-accounts/index.vue' /* webpackChunkName: "pages/compare-savings-accounts/index" */))
const _6dfb8dd6 = () => interopDefault(import('../pages/compare-tv-broadband-phone/index.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/index" */))
const _35f73bb5 = () => interopDefault(import('../pages/competitions/index.vue' /* webpackChunkName: "pages/competitions/index" */))
const _1a03204a = () => interopDefault(import('../pages/corporate-social-responsibility/index.vue' /* webpackChunkName: "pages/corporate-social-responsibility/index" */))
const _455296a5 = () => interopDefault(import('../pages/guaranteed-irish/index.vue' /* webpackChunkName: "pages/guaranteed-irish/index" */))
const _42a296d8 = () => interopDefault(import('../pages/guides/index.vue' /* webpackChunkName: "pages/guides/index" */))
const _78ced3bc = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _c26932a8 = () => interopDefault(import('../pages/insurance.vue' /* webpackChunkName: "pages/insurance" */))
const _6a18601f = () => interopDefault(import('../pages/market-analysis.vue' /* webpackChunkName: "pages/market-analysis" */))
const _5aec2db9 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _886f8c62 = () => interopDefault(import('../pages/newsroom/index.vue' /* webpackChunkName: "pages/newsroom/index" */))
const _4dfce849 = () => interopDefault(import('../pages/partners.vue' /* webpackChunkName: "pages/partners" */))
const _6e2ab050 = () => interopDefault(import('../pages/podcasts/index.vue' /* webpackChunkName: "pages/podcasts/index" */))
const _a1d896d6 = () => interopDefault(import('../pages/press.vue' /* webpackChunkName: "pages/press" */))
const _41848e4c = () => interopDefault(import('../pages/price-change-calendar/index.vue' /* webpackChunkName: "pages/price-change-calendar/index" */))
const _78f29ddd = () => interopDefault(import('../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _3cf438fc = () => interopDefault(import('../pages/reasons-why.vue' /* webpackChunkName: "pages/reasons-why" */))
const _5c7771ed = () => interopDefault(import('../pages/reviews.vue' /* webpackChunkName: "pages/reviews" */))
const _a9d50414 = () => interopDefault(import('../pages/speed-test.vue' /* webpackChunkName: "pages/speed-test" */))
const _71f1979c = () => interopDefault(import('../pages/terms/index.vue' /* webpackChunkName: "pages/terms/index" */))
const _b0d6b086 = () => interopDefault(import('../pages/about/team.vue' /* webpackChunkName: "pages/about/team" */))
const _6e66c90e = () => interopDefault(import('../pages/blog/authors.vue' /* webpackChunkName: "pages/blog/authors" */))
const _15f07d4a = () => interopDefault(import('../pages/compare-car-insurance/about-you.vue' /* webpackChunkName: "pages/compare-car-insurance/about-you" */))
const _01af81d9 = () => interopDefault(import('../pages/compare-car-insurance/additional-drivers.vue' /* webpackChunkName: "pages/compare-car-insurance/additional-drivers" */))
const _3aba656d = () => interopDefault(import('../pages/compare-car-insurance/declarations.vue' /* webpackChunkName: "pages/compare-car-insurance/declarations" */))
const _aa0aec38 = () => interopDefault(import('../pages/compare-car-insurance/driving-experience.vue' /* webpackChunkName: "pages/compare-car-insurance/driving-experience" */))
const _338e829e = () => interopDefault(import('../pages/compare-car-insurance/providers.vue' /* webpackChunkName: "pages/compare-car-insurance/providers" */))
const _64015090 = () => interopDefault(import('../pages/compare-car-insurance/thank-you.vue' /* webpackChunkName: "pages/compare-car-insurance/thank-you" */))
const _648503ee = () => interopDefault(import('../pages/compare-car-insurance/your-car.vue' /* webpackChunkName: "pages/compare-car-insurance/your-car" */))
const _a45b63e0 = () => interopDefault(import('../pages/compare-car-insurance/your-results.vue' /* webpackChunkName: "pages/compare-car-insurance/your-results" */))
const _36037ba8 = () => interopDefault(import('../pages/compare-credit-cards/providers.vue' /* webpackChunkName: "pages/compare-credit-cards/providers" */))
const _41f73a40 = () => interopDefault(import('../pages/compare-credit-cards/rate-changes.vue' /* webpackChunkName: "pages/compare-credit-cards/rate-changes" */))
const _5f175e7c = () => interopDefault(import('../pages/compare-credit-cards/thank-you.vue' /* webpackChunkName: "pages/compare-credit-cards/thank-you" */))
const _cfd97e74 = () => interopDefault(import('../pages/compare-credit-cards/your-results.vue' /* webpackChunkName: "pages/compare-credit-cards/your-results" */))
const _357eff93 = () => interopDefault(import('../pages/compare-current-accounts/providers.vue' /* webpackChunkName: "pages/compare-current-accounts/providers" */))
const _0893aa75 = () => interopDefault(import('../pages/compare-current-accounts/rate-changes.vue' /* webpackChunkName: "pages/compare-current-accounts/rate-changes" */))
const _602056a6 = () => interopDefault(import('../pages/compare-current-accounts/thank-you.vue' /* webpackChunkName: "pages/compare-current-accounts/thank-you" */))
const _5eafb0fb = () => interopDefault(import('../pages/compare-current-accounts/your-results.vue' /* webpackChunkName: "pages/compare-current-accounts/your-results" */))
const _e46dade4 = () => interopDefault(import('../pages/compare-health-insurance/apply.vue' /* webpackChunkName: "pages/compare-health-insurance/apply" */))
const _7af9355c = () => interopDefault(import('../pages/compare-health-insurance/thank-you.vue' /* webpackChunkName: "pages/compare-health-insurance/thank-you" */))
const _e6c147fc = () => interopDefault(import('../pages/compare-home-insurance/about-you.vue' /* webpackChunkName: "pages/compare-home-insurance/about-you" */))
const _2e107566 = () => interopDefault(import('../pages/compare-home-insurance/declarations.vue' /* webpackChunkName: "pages/compare-home-insurance/declarations" */))
const _69b3c576 = () => interopDefault(import('../pages/compare-home-insurance/providers.vue' /* webpackChunkName: "pages/compare-home-insurance/providers" */))
const _6596f25f = () => interopDefault(import('../pages/compare-home-insurance/thank-you.vue' /* webpackChunkName: "pages/compare-home-insurance/thank-you" */))
const _abe36148 = () => interopDefault(import('../pages/compare-home-insurance/your-home.vue' /* webpackChunkName: "pages/compare-home-insurance/your-home" */))
const _bdaf43ee = () => interopDefault(import('../pages/compare-home-insurance/your-results.vue' /* webpackChunkName: "pages/compare-home-insurance/your-results" */))
const _f1d3b4c2 = () => interopDefault(import('../pages/compare-insurance/commission-summary.vue' /* webpackChunkName: "pages/compare-insurance/commission-summary" */))
const _29929062 = () => interopDefault(import('../pages/compare-life-insurance/providers.vue' /* webpackChunkName: "pages/compare-life-insurance/providers" */))
const _0e4faf18 = () => interopDefault(import('../pages/compare-life-insurance/search.vue' /* webpackChunkName: "pages/compare-life-insurance/search" */))
const _60df8c68 = () => interopDefault(import('../pages/compare-life-insurance/your-results.vue' /* webpackChunkName: "pages/compare-life-insurance/your-results" */))
const _1fd956f5 = () => interopDefault(import('../pages/compare-loans/lenders.vue' /* webpackChunkName: "pages/compare-loans/lenders" */))
const _39558730 = () => interopDefault(import('../pages/compare-loans/rate-changes.vue' /* webpackChunkName: "pages/compare-loans/rate-changes" */))
const _3b59bf9a = () => interopDefault(import('../pages/compare-loans/thank-you.vue' /* webpackChunkName: "pages/compare-loans/thank-you" */))
const _397142ee = () => interopDefault(import('../pages/compare-loans/your-results.vue' /* webpackChunkName: "pages/compare-loans/your-results" */))
const _623845c9 = () => interopDefault(import('../pages/compare-mortgages/lenders.vue' /* webpackChunkName: "pages/compare-mortgages/lenders" */))
const _8b3e6700 = () => interopDefault(import('../pages/compare-mortgages/lifetime-loans/index.vue' /* webpackChunkName: "pages/compare-mortgages/lifetime-loans/index" */))
const _12431bd8 = () => interopDefault(import('../pages/compare-mortgages/rate-changes.vue' /* webpackChunkName: "pages/compare-mortgages/rate-changes" */))
const _61b8496e = () => interopDefault(import('../pages/compare-mortgages/thank-you.vue' /* webpackChunkName: "pages/compare-mortgages/thank-you" */))
const _4cfa789a = () => interopDefault(import('../pages/compare-mortgages/your-results.vue' /* webpackChunkName: "pages/compare-mortgages/your-results" */))
const _13189646 = () => interopDefault(import('../pages/compare-prepaid-credit-cards/providers.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/providers" */))
const _46489a3c = () => interopDefault(import('../pages/compare-prepaid-credit-cards/rate-changes.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/rate-changes" */))
const _a4ed2940 = () => interopDefault(import('../pages/compare-prepaid-credit-cards/thank-you.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/thank-you" */))
const _32f7b968 = () => interopDefault(import('../pages/compare-prepaid-credit-cards/your-results.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/your-results" */))
const _3cc6a853 = () => interopDefault(import('../pages/compare-savings-accounts/providers.vue' /* webpackChunkName: "pages/compare-savings-accounts/providers" */))
const _34a249b5 = () => interopDefault(import('../pages/compare-savings-accounts/rate-changes.vue' /* webpackChunkName: "pages/compare-savings-accounts/rate-changes" */))
const _71af04c7 = () => interopDefault(import('../pages/compare-savings-accounts/search.vue' /* webpackChunkName: "pages/compare-savings-accounts/search" */))
const _51910526 = () => interopDefault(import('../pages/compare-savings-accounts/thank-you.vue' /* webpackChunkName: "pages/compare-savings-accounts/thank-you" */))
const _ea835f8a = () => interopDefault(import('../pages/compare-savings-accounts/your-results.vue' /* webpackChunkName: "pages/compare-savings-accounts/your-results" */))
const _22653a72 = () => interopDefault(import('../pages/compare-tv-broadband-phone/apply.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/apply" */))
const _8a774e7a = () => interopDefault(import('../pages/compare-tv-broadband-phone/price-changes.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/price-changes" */))
const _8795c0b4 = () => interopDefault(import('../pages/compare-tv-broadband-phone/providers.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/providers" */))
const _56a5f4c0 = () => interopDefault(import('../pages/compare-tv-broadband-phone/thank-you.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/thank-you" */))
const _3a6397f0 = () => interopDefault(import('../pages/compare-tv-broadband-phone/your-results.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/your-results" */))
const _501546d6 = () => interopDefault(import('../pages/customer-satisfaction/broadband.vue' /* webpackChunkName: "pages/customer-satisfaction/broadband" */))
const _5f94abca = () => interopDefault(import('../pages/compare-car-insurance/apply/optional-addons.vue' /* webpackChunkName: "pages/compare-car-insurance/apply/optional-addons" */))
const _2d2dc6ce = () => interopDefault(import('../pages/compare-life-insurance/apply/declaration.vue' /* webpackChunkName: "pages/compare-life-insurance/apply/declaration" */))
const _0b27c654 = () => interopDefault(import('../pages/compare-life-insurance/apply/second-life.vue' /* webpackChunkName: "pages/compare-life-insurance/apply/second-life" */))
const _51da169b = () => interopDefault(import('../pages/compare-life-insurance/apply/thank-you.vue' /* webpackChunkName: "pages/compare-life-insurance/apply/thank-you" */))
const _76957688 = () => interopDefault(import('../pages/admin/car-insurance/plans/previews.vue' /* webpackChunkName: "pages/admin/car-insurance/plans/previews" */))
const _4cb2a4c5 = () => interopDefault(import('../pages/admin/home-insurance/plans/previews.vue' /* webpackChunkName: "pages/admin/home-insurance/plans/previews" */))
const _bee8d5ee = () => interopDefault(import('../pages/compare-mortgages/lifetime-loans/apply/thank-you.vue' /* webpackChunkName: "pages/compare-mortgages/lifetime-loans/apply/thank-you" */))
const _6f6c297b = () => interopDefault(import('../pages/compare-mortgages/lifetime-loans/apply/_step/index.vue' /* webpackChunkName: "pages/compare-mortgages/lifetime-loans/apply/_step/index" */))
const _4c30c60a = () => interopDefault(import('../pages/compare-car-insurance/unsubscribe/_code.vue' /* webpackChunkName: "pages/compare-car-insurance/unsubscribe/_code" */))
const _4032c9b1 = () => interopDefault(import('../pages/compare-home-insurance/unsubscribe/_code.vue' /* webpackChunkName: "pages/compare-home-insurance/unsubscribe/_code" */))
const _5bf3862b = () => interopDefault(import('../pages/compare-life-insurance/apply/_code.vue' /* webpackChunkName: "pages/compare-life-insurance/apply/_code" */))
const _6a71f0ea = () => interopDefault(import('../pages/account/orders/_order-type/_code.vue' /* webpackChunkName: "pages/account/orders/_order-type/_code" */))
const _1ca297cf = () => interopDefault(import('../pages/compare-car-insurance/_provider/index.vue' /* webpackChunkName: "pages/compare-car-insurance/_provider/index" */))
const _78b72159 = () => interopDefault(import('../pages/compare-credit-cards/_provider/index.vue' /* webpackChunkName: "pages/compare-credit-cards/_provider/index" */))
const _0f9cc904 = () => interopDefault(import('../pages/compare-current-accounts/_provider/index.vue' /* webpackChunkName: "pages/compare-current-accounts/_provider/index" */))
const _68cf5936 = () => interopDefault(import('../pages/compare-home-insurance/_provider/index.vue' /* webpackChunkName: "pages/compare-home-insurance/_provider/index" */))
const _9e237ada = () => interopDefault(import('../pages/compare-life-insurance/_provider/index.vue' /* webpackChunkName: "pages/compare-life-insurance/_provider/index" */))
const _18d7e39e = () => interopDefault(import('../pages/compare-loans/_provider/index.vue' /* webpackChunkName: "pages/compare-loans/_provider/index" */))
const _5fd0e905 = () => interopDefault(import('../pages/compare-mortgages/_provider/index.vue' /* webpackChunkName: "pages/compare-mortgages/_provider/index" */))
const _7a294d77 = () => interopDefault(import('../pages/compare-prepaid-credit-cards/_provider/index.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/_provider/index" */))
const _0932e1c4 = () => interopDefault(import('../pages/compare-savings-accounts/_provider/index.vue' /* webpackChunkName: "pages/compare-savings-accounts/_provider/index" */))
const _2b5d6252 = () => interopDefault(import('../pages/compare-tv-broadband-phone/_provider/index.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/_provider/index" */))
const _dd80afe2 = () => interopDefault(import('../pages/compare-mortgages/_purpose/stage/index.vue' /* webpackChunkName: "pages/compare-mortgages/_purpose/stage/index" */))
const _7d175f02 = () => interopDefault(import('../pages/compare-mortgages/_purpose/stage/_stage/thank-you.vue' /* webpackChunkName: "pages/compare-mortgages/_purpose/stage/_stage/thank-you" */))
const _0dd8411e = () => interopDefault(import('../pages/compare-mortgages/_purpose/stage/_stage/_step/index.vue' /* webpackChunkName: "pages/compare-mortgages/_purpose/stage/_stage/_step/index" */))
const _97159968 = () => interopDefault(import('../pages/blog/_category/_slug/index.vue' /* webpackChunkName: "pages/blog/_category/_slug/index" */))
const _4c864ee1 = () => interopDefault(import('../pages/guides/_category/_slug/index.vue' /* webpackChunkName: "pages/guides/_category/_slug/index" */))
const _29d12564 = () => interopDefault(import('../pages/compare-credit-cards/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-credit-cards/_provider/_code/_slug" */))
const _eea52e8e = () => interopDefault(import('../pages/compare-current-accounts/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-current-accounts/_provider/_code/_slug" */))
const _f04989f0 = () => interopDefault(import('../pages/compare-life-insurance/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-life-insurance/_provider/_code/_slug" */))
const _9c554fb4 = () => interopDefault(import('../pages/compare-loans/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-loans/_provider/_code/_slug" */))
const _43a0780c = () => interopDefault(import('../pages/compare-mortgages/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-mortgages/_provider/_code/_slug" */))
const _54338aec = () => interopDefault(import('../pages/compare-prepaid-credit-cards/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-prepaid-credit-cards/_provider/_code/_slug" */))
const _88041d0e = () => interopDefault(import('../pages/compare-savings-accounts/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-savings-accounts/_provider/_code/_slug" */))
const _7a25f768 = () => interopDefault(import('../pages/compare-tv-broadband-phone/_provider/_code/_slug.vue' /* webpackChunkName: "pages/compare-tv-broadband-phone/_provider/_code/_slug" */))
const _53539a71 = () => interopDefault(import('../pages/podcasts/_year/_month/_day/_slug.vue' /* webpackChunkName: "pages/podcasts/_year/_month/_day/_slug" */))
const _d62bff9a = () => interopDefault(import('../pages/media/_year/_month/_day/_publication/_slug/_id.vue' /* webpackChunkName: "pages/media/_year/_month/_day/_publication/_slug/_id" */))
const _95a74cb8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _61b31c08 = () => interopDefault(import('../pages/*.vue' /* webpackChunkName: "pages/*" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about/",
    component: _27f82222,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/account/",
    component: _4da4ba42,
    pathToRegexpOptions: {"strict":true},
    name: "account___en"
  }, {
    path: "/accredited-by-cru/",
    component: _23784316,
    pathToRegexpOptions: {"strict":true},
    name: "accredited-by-cru___en"
  }, {
    path: "/ads/",
    component: _152c4e05,
    pathToRegexpOptions: {"strict":true},
    name: "ads___en"
  }, {
    path: "/awards/",
    component: _43d92d58,
    pathToRegexpOptions: {"strict":true},
    name: "awards___en"
  }, {
    path: "/banking/",
    component: _7f2baa92,
    pathToRegexpOptions: {"strict":true},
    name: "money/banking/___en"
  }, {
    path: "/blog/",
    component: _4df49d7a,
    pathToRegexpOptions: {"strict":true},
    name: "blog___en"
  }, {
    path: "/careers/",
    component: _4e66ecf2,
    pathToRegexpOptions: {"strict":true},
    name: "careers___en"
  }, {
    path: "/commission-summary/",
    component: _173f7462,
    pathToRegexpOptions: {"strict":true},
    name: "commission-summary___en"
  }, {
    path: "/compare-car-insurance/",
    component: _65ad2cce,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance___en"
  }, {
    path: "/compare-credit-cards/",
    component: _6c678a50,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards___en"
  }, {
    path: "/compare-current-accounts/",
    component: _5ce46c43,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts___en"
  }, {
    path: "/compare-gas-electricity-prices/",
    component: _69b526a3,
    pathToRegexpOptions: {"strict":true},
    name: "compare-gas-electricity-prices___en"
  }, {
    path: "/compare-health-insurance/",
    component: _4d41071c,
    pathToRegexpOptions: {"strict":true},
    name: "compare-health-insurance___en"
  }, {
    path: "/compare-home-insurance/",
    component: _3ddb9a16,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance___en"
  }, {
    path: "/compare-insurance/",
    component: _20052d72,
    pathToRegexpOptions: {"strict":true},
    name: "compare-insurance___en"
  }, {
    path: "/compare-life-insurance/",
    component: _6646bc92,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance___en"
  }, {
    path: "/compare-loans/",
    component: _64aa54a0,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans___en"
  }, {
    path: "/compare-mortgages/",
    component: _ea412cf8,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages___en"
  }, {
    path: "/compare-prepaid-credit-cards/",
    component: _3d395714,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards___en"
  }, {
    path: "/compare-savings-accounts/",
    component: _144315fa,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts___en"
  }, {
    path: "/compare-tv-broadband-phone/",
    component: _6dfb8dd6,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone___en"
  }, {
    path: "/competitions/",
    component: _35f73bb5,
    pathToRegexpOptions: {"strict":true},
    name: "competitions___en"
  }, {
    path: "/corporate-social-responsibility/",
    component: _1a03204a,
    pathToRegexpOptions: {"strict":true},
    name: "corporate-social-responsibility___en"
  }, {
    path: "/guaranteed-irish/",
    component: _455296a5,
    pathToRegexpOptions: {"strict":true},
    name: "guaranteed-irish___en"
  }, {
    path: "/guides/",
    component: _42a296d8,
    pathToRegexpOptions: {"strict":true},
    name: "guides___en"
  }, {
    path: "/help/",
    component: _78ced3bc,
    pathToRegexpOptions: {"strict":true},
    name: "help___en"
  }, {
    path: "/insurance/",
    component: _c26932a8,
    pathToRegexpOptions: {"strict":true},
    name: "insurance___en"
  }, {
    path: "/market-analysis/",
    component: _6a18601f,
    pathToRegexpOptions: {"strict":true},
    name: "market-analysis___en"
  }, {
    path: "/media/",
    component: _5aec2db9,
    pathToRegexpOptions: {"strict":true},
    name: "media___en"
  }, {
    path: "/money/",
    component: _7f2baa92,
    pathToRegexpOptions: {"strict":true},
    name: "money___en"
  }, {
    path: "/newsroom/",
    component: _886f8c62,
    pathToRegexpOptions: {"strict":true},
    name: "newsroom___en"
  }, {
    path: "/partners/",
    component: _4dfce849,
    pathToRegexpOptions: {"strict":true},
    name: "partners___en"
  }, {
    path: "/podcasts/",
    component: _6e2ab050,
    pathToRegexpOptions: {"strict":true},
    name: "podcasts___en"
  }, {
    path: "/press/",
    component: _a1d896d6,
    pathToRegexpOptions: {"strict":true},
    name: "press___en"
  }, {
    path: "/pressclippings/",
    component: _5aec2db9,
    pathToRegexpOptions: {"strict":true},
    name: "media/pressclippings/___en"
  }, {
    path: "/price-change-calendar/",
    component: _41848e4c,
    pathToRegexpOptions: {"strict":true},
    name: "price-change-calendar___en"
  }, {
    path: "/privacy/",
    component: _78f29ddd,
    pathToRegexpOptions: {"strict":true},
    name: "privacy___en"
  }, {
    path: "/reasons-why/",
    component: _3cf438fc,
    pathToRegexpOptions: {"strict":true},
    name: "reasons-why___en"
  }, {
    path: "/reviews/",
    component: _5c7771ed,
    pathToRegexpOptions: {"strict":true},
    name: "reviews___en"
  }, {
    path: "/speed-test/",
    component: _a9d50414,
    pathToRegexpOptions: {"strict":true},
    name: "speed-test___en"
  }, {
    path: "/terms/",
    component: _71f1979c,
    pathToRegexpOptions: {"strict":true},
    name: "terms___en"
  }, {
    path: "/about/team/",
    component: _b0d6b086,
    pathToRegexpOptions: {"strict":true},
    name: "about-team___en"
  }, {
    path: "/blog/authors/",
    component: _6e66c90e,
    pathToRegexpOptions: {"strict":true},
    name: "blog-authors___en"
  }, {
    path: "/compare-car-insurance/about-you/",
    component: _15f07d4a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-about-you___en"
  }, {
    path: "/compare-car-insurance/additional-drivers/",
    component: _01af81d9,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-additional-drivers___en"
  }, {
    path: "/compare-car-insurance/declarations/",
    component: _3aba656d,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-declarations___en"
  }, {
    path: "/compare-car-insurance/driving-experience/",
    component: _aa0aec38,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-driving-experience___en"
  }, {
    path: "/compare-car-insurance/providers/",
    component: _338e829e,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-providers___en"
  }, {
    path: "/compare-car-insurance/thank-you/",
    component: _64015090,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-thank-you___en"
  }, {
    path: "/compare-car-insurance/your-car/",
    component: _648503ee,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-your-car___en"
  }, {
    path: "/compare-car-insurance/your-results/",
    component: _a45b63e0,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-your-results___en"
  }, {
    path: "/compare-credit-cards/providers/",
    component: _36037ba8,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards-providers___en"
  }, {
    path: "/compare-credit-cards/rate-changes/",
    component: _41f73a40,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards-rate-changes___en"
  }, {
    path: "/compare-credit-cards/thank-you/",
    component: _5f175e7c,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards-thank-you___en"
  }, {
    path: "/compare-credit-cards/your-results/",
    component: _cfd97e74,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards-your-results___en"
  }, {
    path: "/compare-current-accounts/providers/",
    component: _357eff93,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts-providers___en"
  }, {
    path: "/compare-current-accounts/rate-changes/",
    component: _0893aa75,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts-rate-changes___en"
  }, {
    path: "/compare-current-accounts/thank-you/",
    component: _602056a6,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts-thank-you___en"
  }, {
    path: "/compare-current-accounts/your-results/",
    component: _5eafb0fb,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts-your-results___en"
  }, {
    path: "/compare-health-insurance/apply/",
    component: _e46dade4,
    pathToRegexpOptions: {"strict":true},
    name: "compare-health-insurance-apply___en"
  }, {
    path: "/compare-health-insurance/thank-you/",
    component: _7af9355c,
    pathToRegexpOptions: {"strict":true},
    name: "compare-health-insurance-thank-you___en"
  }, {
    path: "/compare-home-insurance/about-you/",
    component: _e6c147fc,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-about-you___en"
  }, {
    path: "/compare-home-insurance/declarations/",
    component: _2e107566,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-declarations___en"
  }, {
    path: "/compare-home-insurance/providers/",
    component: _69b3c576,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-providers___en"
  }, {
    path: "/compare-home-insurance/thank-you/",
    component: _6596f25f,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-thank-you___en"
  }, {
    path: "/compare-home-insurance/your-home/",
    component: _abe36148,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-your-home___en"
  }, {
    path: "/compare-home-insurance/your-results/",
    component: _bdaf43ee,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-your-results___en"
  }, {
    path: "/compare-insurance/commission-summary/",
    component: _f1d3b4c2,
    pathToRegexpOptions: {"strict":true},
    name: "compare-insurance-commission-summary___en"
  }, {
    path: "/compare-life-insurance/providers/",
    component: _29929062,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-providers___en"
  }, {
    path: "/compare-life-insurance/search/",
    component: _0e4faf18,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-search___en"
  }, {
    path: "/compare-life-insurance/your-results/",
    component: _60df8c68,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-your-results___en"
  }, {
    path: "/compare-loans/lenders/",
    component: _1fd956f5,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans-lenders___en"
  }, {
    path: "/compare-loans/rate-changes/",
    component: _39558730,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans-rate-changes___en"
  }, {
    path: "/compare-loans/thank-you/",
    component: _3b59bf9a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans-thank-you___en"
  }, {
    path: "/compare-loans/your-results/",
    component: _397142ee,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans-your-results___en"
  }, {
    path: "/compare-mortgages/lenders/",
    component: _623845c9,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-lenders___en"
  }, {
    path: "/compare-mortgages/lifetime-loans/",
    component: _8b3e6700,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-lifetime-loans___en"
  }, {
    path: "/compare-mortgages/rate-changes/",
    component: _12431bd8,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-rate-changes___en"
  }, {
    path: "/compare-mortgages/thank-you/",
    component: _61b8496e,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-thank-you___en"
  }, {
    path: "/compare-mortgages/your-results/",
    component: _4cfa789a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-your-results___en"
  }, {
    path: "/compare-prepaid-credit-cards/providers/",
    component: _13189646,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards-providers___en"
  }, {
    path: "/compare-prepaid-credit-cards/rate-changes/",
    component: _46489a3c,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards-rate-changes___en"
  }, {
    path: "/compare-prepaid-credit-cards/thank-you/",
    component: _a4ed2940,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards-thank-you___en"
  }, {
    path: "/compare-prepaid-credit-cards/your-results/",
    component: _32f7b968,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards-your-results___en"
  }, {
    path: "/compare-savings-accounts/providers/",
    component: _3cc6a853,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-providers___en"
  }, {
    path: "/compare-savings-accounts/rate-changes/",
    component: _34a249b5,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-rate-changes___en"
  }, {
    path: "/compare-savings-accounts/search/",
    component: _71af04c7,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-search___en"
  }, {
    path: "/compare-savings-accounts/thank-you/",
    component: _51910526,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-thank-you___en"
  }, {
    path: "/compare-savings-accounts/your-results/",
    component: _ea835f8a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-your-results___en"
  }, {
    path: "/compare-tv-broadband-phone/apply/",
    component: _22653a72,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-apply___en"
  }, {
    path: "/compare-tv-broadband-phone/price-changes/",
    component: _8a774e7a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-price-changes___en"
  }, {
    path: "/compare-tv-broadband-phone/providers/",
    component: _8795c0b4,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-providers___en"
  }, {
    path: "/compare-tv-broadband-phone/thank-you/",
    component: _56a5f4c0,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-thank-you___en"
  }, {
    path: "/compare-tv-broadband-phone/your-results/",
    component: _3a6397f0,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-your-results___en"
  }, {
    path: "/customer-satisfaction/broadband/",
    component: _501546d6,
    pathToRegexpOptions: {"strict":true},
    name: "customer-satisfaction-broadband___en"
  }, {
    path: "/compare-car-insurance/apply/optional-addons/",
    component: _5f94abca,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-apply-optional-addons___en"
  }, {
    path: "/compare-life-insurance/apply/declaration/",
    component: _2d2dc6ce,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-declaration___en"
  }, {
    path: "/compare-life-insurance/apply/second-life/",
    component: _0b27c654,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-second-life___en"
  }, {
    path: "/compare-life-insurance/apply/thank-you/",
    component: _51da169b,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-thank-you___en"
  }, {
    path: "/admin/car-insurance/plans/previews/",
    component: _76957688,
    pathToRegexpOptions: {"strict":true},
    name: "admin-car-insurance-plans-previews___en"
  }, {
    path: "/admin/home-insurance/plans/previews/",
    component: _4cb2a4c5,
    pathToRegexpOptions: {"strict":true},
    name: "admin-home-insurance-plans-previews___en"
  }, {
    path: "/compare-mortgages/lifetime-loans/apply/thank-you/",
    component: _bee8d5ee,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-lifetime-loans-apply-thank-you___en"
  }, {
    path: "/compare-mortgages/lifetime-loans/apply/:step/",
    component: _6f6c297b,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-lifetime-loans-apply-step___en"
  }, {
    path: "/blog/authors/:author/",
    component: _4df49d7a,
    pathToRegexpOptions: {"strict":true},
    name: "blog/blog/authors/:author/___en"
  }, {
    path: "/blog/tag/:tag/",
    component: _4df49d7a,
    pathToRegexpOptions: {"strict":true},
    name: "blog/blog/tag/:tag/___en"
  }, {
    path: "/compare-car-insurance/unsubscribe/:code?/",
    component: _4c30c60a,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-unsubscribe-code___en"
  }, {
    path: "/compare-car-insurance/your-results/:uuid/",
    component: _a45b63e0,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-your-results/compare-car-insurance/your-results/:uuid/___en"
  }, {
    path: "/compare-home-insurance/unsubscribe/:code?/",
    component: _4032c9b1,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-unsubscribe-code___en"
  }, {
    path: "/compare-home-insurance/your-results/:uuid/",
    component: _bdaf43ee,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-your-results/compare-home-insurance/your-results/:uuid/___en"
  }, {
    path: "/compare-life-insurance/apply/:code?/",
    component: _5bf3862b,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-code___en"
  }, {
    path: "/account/orders/:order-type?/:code?/",
    component: _6a71f0ea,
    pathToRegexpOptions: {"strict":true},
    name: "account-orders-order-type-code___en"
  }, {
    path: "/account/orders/:orderType(commsapplication|energyapplication|mortgage-lead|life-insurance-application|home-insurance-order|motor-insurance-order)/:code/",
    component: _6a71f0ea,
    pathToRegexpOptions: {"strict":true},
    name: "account-orders-order-type-code/account/orders/:orderType(commsapplication|energyapplication|mortgage-lead|life-insurance-application|home-insurance-order|motor-insurance-order)/:code___en"
  }, {
    path: "/compare-tv-broadband-phone/apply/:provider/:code/:slug/",
    component: _22653a72,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-apply/compare-tv-broadband-phone/apply/:provider/:code/:slug/___en"
  }, {
    path: "/compare-tv-broadband-phone/apply/:provider/:code/:slug/sp/",
    component: _22653a72,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-apply/compare-tv-broadband-phone/apply/:provider/:code/:slug/sp/___en"
  }, {
    path: "/account/:subpage(profile|household|orders|settings)/",
    component: _4da4ba42,
    pathToRegexpOptions: {"strict":true},
    name: "account/account/:subpage(profile|household|orders|settings)/___en"
  }, {
    path: "/blog/:category/",
    component: _4df49d7a,
    pathToRegexpOptions: {"strict":true},
    name: "blog/blog/:category/___en"
  }, {
    path: "/compare-car-insurance/:provider/",
    component: _1ca297cf,
    pathToRegexpOptions: {"strict":true},
    name: "compare-car-insurance-provider___en"
  }, {
    path: "/compare-credit-cards/:provider/",
    component: _78b72159,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards-provider___en"
  }, {
    path: "/compare-current-accounts/:provider/",
    component: _0f9cc904,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts-provider___en"
  }, {
    path: "/compare-home-insurance/:provider/",
    component: _68cf5936,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-insurance-provider___en"
  }, {
    path: "/compare-life-insurance/:provider/",
    component: _9e237ada,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-provider___en"
  }, {
    path: "/compare-loans/:provider/",
    component: _18d7e39e,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans-provider___en"
  }, {
    path: "/compare-mortgages/:provider/",
    component: _5fd0e905,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-provider___en"
  }, {
    path: "/compare-prepaid-credit-cards/:provider/",
    component: _7a294d77,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards-provider___en"
  }, {
    path: "/compare-savings-accounts/:provider/",
    component: _0932e1c4,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-provider___en"
  }, {
    path: "/compare-tv-broadband-phone/:provider/",
    component: _2b5d6252,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-provider___en"
  }, {
    path: "/guides/:category/",
    component: _42a296d8,
    pathToRegexpOptions: {"strict":true},
    name: "guides/guides/:category/___en"
  }, {
    path: "/compare-mortgages/:purpose?/stage/",
    component: _dd80afe2,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-purpose-stage___en"
  }, {
    path: "/compare-mortgages/:purpose?/stage/:stage?/thank-you/",
    component: _7d175f02,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-purpose-stage-stage-thank-you___en"
  }, {
    path: "/compare-mortgages/:purpose?/stage/:stage?/:step/",
    component: _0dd8411e,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-purpose-stage-stage-step___en"
  }, {
    path: "/blog/:category/:slug/",
    component: _97159968,
    pathToRegexpOptions: {"strict":true},
    name: "blog-category-slug___en"
  }, {
    path: "/guides/:category/:slug/",
    component: _4c864ee1,
    pathToRegexpOptions: {"strict":true},
    name: "guides-category-slug___en"
  }, {
    path: "/compare-credit-cards/:provider?/:code?/:slug/",
    component: _29d12564,
    pathToRegexpOptions: {"strict":true},
    name: "compare-credit-cards-provider-code-slug___en"
  }, {
    path: "/compare-current-accounts/:provider?/:code?/:slug/",
    component: _eea52e8e,
    pathToRegexpOptions: {"strict":true},
    name: "compare-current-accounts-provider-code-slug___en"
  }, {
    path: "/compare-life-insurance/:provider?/:code?/:slug/",
    component: _f04989f0,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-provider-code-slug___en"
  }, {
    path: "/compare-loans/:provider?/:code/:slug/",
    component: _9c554fb4,
    pathToRegexpOptions: {"strict":true},
    name: "compare-loans-provider-code-slug___en"
  }, {
    path: "/compare-mortgages/:provider?/:code/:slug/",
    component: _43a0780c,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-provider-code-slug___en"
  }, {
    path: "/compare-prepaid-credit-cards/:provider?/:code?/:slug?/",
    component: _54338aec,
    pathToRegexpOptions: {"strict":true},
    name: "compare-prepaid-credit-cards-provider-code-slug___en"
  }, {
    path: "/compare-savings-accounts/:provider?/:code?/:slug/",
    component: _88041d0e,
    pathToRegexpOptions: {"strict":true},
    name: "compare-savings-accounts-provider-code-slug___en"
  }, {
    path: "/compare-tv-broadband-phone/:provider?/:code?/:slug?/",
    component: _7a25f768,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-provider-code-slug___en"
  }, {
    path: "/compare-tv-broadband-phone/:provider/:code/:slug/",
    component: _7a25f768,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-provider-code-slug/compare-tv-broadband-phone/:provider/:code/:slug/___en"
  }, {
    path: "/compare-mortgages/:provider/:code/:slug/about/",
    component: _43a0780c,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-provider-code-slug/compare-mortgages/:provider/:code/:slug/about/___en"
  }, {
    path: "/compare-tv-broadband-phone/:provider/:code/:slug/sp/",
    component: _7a25f768,
    pathToRegexpOptions: {"strict":true},
    name: "compare-tv-broadband-phone-provider-code-slug/compare-tv-broadband-phone/:provider/:code/:slug/sp/___en"
  }, {
    path: "/podcasts/:year/:month?/:day?/:slug?/",
    component: _53539a71,
    pathToRegexpOptions: {"strict":true},
    name: "podcasts-year-month-day-slug___en"
  }, {
    path: "/podcasts/:year/:month/:day/:slug/:id/",
    component: _53539a71,
    pathToRegexpOptions: {"strict":true},
    name: "podcasts-year-month-day-slug/podcasts/:year/:month/:day/:slug/:id/___en"
  }, {
    path: "/media/:year/:month?/:day?/:publication?/:slug?/:id?/",
    component: _d62bff9a,
    pathToRegexpOptions: {"strict":true},
    name: "media-year-month-day-publication-slug-id___en"
  }, {
    path: "/",
    component: _95a74cb8,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/",
    component: _6646bc92,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/providers/",
    component: _29929062,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-providers/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/providers/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/search/",
    component: _0e4faf18,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-search/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/search/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/your-results/",
    component: _60df8c68,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-your-results/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/your-results/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/declaration/",
    component: _2d2dc6ce,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-declaration/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/declaration/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/second-life/",
    component: _0b27c654,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-second-life/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/second-life/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/thank-you/",
    component: _51da169b,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-thank-you/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/thank-you/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/:code/",
    component: _5bf3862b,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-apply-code/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/apply/:code/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/:provider/",
    component: _9e237ada,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-provider/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/:provider/___en"
  }, {
    path: "/:purpose(first-time-buyer|moving-home|switching-mortgage)/:stage(applying|considering)/",
    component: _dd80afe2,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mortgages-purpose-stage/:purpose(first-time-buyer|moving-home|switching-mortgage)/:stage(applying|considering)/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/:provider/:code/",
    component: _f04989f0,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-provider-code-slug/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/:provider/:code/___en"
  }, {
    path: "/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/:provider/:code/:slug/",
    component: _f04989f0,
    pathToRegexpOptions: {"strict":true},
    name: "compare-life-insurance-provider-code-slug/:coverType(compare-mortgage-protection-insurance|compare-serious-illness-cover|compare-income-protection-insurance)/:provider/:code/:slug/___en"
  }, {
    path: "/*/",
    component: _61b31c08,
    pathToRegexpOptions: {"strict":true},
    name: "*___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
